import type { AppData } from '../../types/app_data';
import { AppStepSection, StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

// Ask user for email
export const EmailStep: Step = {
  id: 'email',
  pathname: '/email',

  canShow: (appData: AppData) => {
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    if (appData.stepSection === AppStepSection.Challenge) {
      // Skip the step is it's already answered
      if (appData.email) {
        return false;
      }
    }

    if (!!appData.featureData?.prefillQuotingVariation && appData.email) {
      return false;
    }

    // https://www.notion.so/jerrydesign/Show-quotes-right-away-for-MA-prefill-7f4bff642b86440e96089fdbd90c9da3?pvs=4#129b8b3e02c380ea8af3f2dbbb30e004
    return !appData.partnerSkippableData?.email;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    return !!appData.email;
  },
  category: () => StepCategory.Other,
};
